import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import btoa from 'btoa';

import { isMobile, openLogin } from '../../../../mobile/helpers';
import { navigate } from '../../../../helpers';
import Button from '../Button';
import styles from './login-prompt.scss';

const propTypes = {
  prompt: PropTypes.bool,
  text: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

const LoginPrompt = ({
  prompt,
  text,
  history,
  match,
}) => (
  prompt
    ? (
      <div className={styles.container}>
        <div className={styles.prompt}>
          <div className={styles.title}>
            You need to log in.
          </div>
          <div className={styles.message}>
            {text}
          </div>
          <Button
            onClick={isMobile()
              ? () => openLogin()
              : () => navigate(history, `/login/${btoa(match.url)}`)}
          >
            Log in or register
          </Button>
        </div>
      </div>
    )
    : null
);

LoginPrompt.propTypes = propTypes;
LoginPrompt.defaultProps = {
  text: 'You need to log in to your DreamHack account to see this content.',
};

export default withRouter(LoginPrompt);
